module.exports = __webpack_public_path__ + "static/media/sync.bc20c697.svg";